import { render, staticRenderFns } from "./SetStockLimits.vue?vue&type=template&id=7c29e9ca&scoped=true"
import script from "./SetStockLimits.vue?vue&type=script&lang=js"
export * from "./SetStockLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c29e9ca",
  null
  
)

export default component.exports